<template>

  <span>
    <span v-if="decryptedValue">
      {{decryptedValue}}

      <el-tooltip class="item" effect="dark" content="Forgot master password and hide data" placement="top">
        <a href="" @click.prevent="turnOff">
          <span class="b-pf-icon b-pf-icon--encrypted"></span>
        </a>
      </el-tooltip>
    </span>
    <span v-else>
      <a href="" @click.prevent="promptMasterPassword">
        <span class="b-pf-icon b-pf-icon--encrypted"></span>
        <span v-if="label">{{label}}</span>
        <span v-else>encrypted</span>
      </a>
    </span>
  </span>

</template>

<script>
  import cryptozoa from '../cryptozoa';
  import { EventBus } from '../eventBus';

  const MASTER_KEY_SYMBOL = Symbol('masterKey');

  export default {
    components: {},
    props: [ 'value', 'label' ],
    data() {
      return {
        decryptedValue: null
      }
    },
    mounted() {
      EventBus.$on('masterKeySetted', async () => await this.decryptValue());

      if (localStorage.masterKey) {
        this.$store.state[ MASTER_KEY_SYMBOL ] = localStorage.masterKey;
      }
      if (this.$store.state[ MASTER_KEY_SYMBOL ]) {
        this.decryptValue();
      }
    },
    methods: {
      async decryptValue() {
        try {
          const key = this.$store.state[ MASTER_KEY_SYMBOL ];
          const val = await Promise.all(this.value.map(async str => await cryptozoa.asymmetric.decrypt(str, key)));
          this.decryptedValue = val.join('');
        } catch (err) {
          this.decryptedValue = null;
        }
      },
      turnOff() {
        this.$store.state[ MASTER_KEY_SYMBOL ] = null;
        EventBus.$emit('masterKeySetted');
      },
      async promptMasterPassword() {
        try {
          const password = await this.$prompt('Please enter you master password', 'Decryption...', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputType: 'password'
          });
          const { key } = await this.$store.dispatch('getPrivateKey');
          this.$store.state[ MASTER_KEY_SYMBOL ] = await cryptozoa.symmetric.decrypt(key, password.value);
          localStorage.masterKey = this.$store.state[ MASTER_KEY_SYMBOL ];

          this.$message.success('Master password is correct!');
          EventBus.$emit('masterKeySetted');
        } catch (e) {
          if (e === 'cancel') {
            return;
          }
          console.info(e);
          this.$message.error('Wrong master password!');
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// cryptValue.vue?f41f54e2